import { useTheme } from "@emotion/react";
import {
  Clear,
  FilterAltOutlined,
  LaunchOutlined,
  Search,
} from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Chip,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import DatagridComponent from "../../../../components/datagridComponent";
import FilterBar from "../../../../components/topBarFilter";
import useStyles from "./styles";

import dayjs from "dayjs";
import { useNavigate, useOutletContext } from "react-router-dom";
import ButtonTime from "../../../../components/buttonTime";
import ErpFilter from "../../../../components/erp/ErpFilter";
import useErpSelecionado from "../../../../components/erp/useErpSelecionado";
import { maskCnpj, maskCpfCnpj } from "../../../../utils/masks";

function erpConfig(erp) {
  let erpObj = { isNf: false, columnsErpType: "", labelErp: "" };

  switch (erp) {
    case "HUBSOFT":
      erpObj = {
        columnsErpType: erp.toLowerCase(),
        labelErp: "Serviço",
      };
      break;

    case "VOALLE":
      erpObj = {
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
      };
      break;
    case "IXC":
      erpObj = {
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
      };
      break;
    case "VERO":
      erpObj = {
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
      };
      break;
  }
  return erpObj;
}
export default function Contratos() {
  const theme = useTheme();
  const [buscarContrato, setBuscarContrato] = useState("");
  const [allContratos, setAllContratos] = useState([]);
  const [snackbar, setSnackbar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingBuscar, setLoadingBuscar] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [filterData, setFilterData] = useState({
    initialDate: null,
    finalDate: null,
  });
  const [isValidRange, setIsValidRange] = useState(false);
  const [selectTime, setSelectTime] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectStatusContrato, setSelectStatusContrato] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const open = Boolean(anchorEl);
  const styles = useStyles(theme);
  const navigate = useNavigate();
  // ERP escolhido: contratos só dos clientes dele, com as colunas dele.
  const { erps, erpId, setErpId, erp, carregado, variosErps } =
    useErpSelecionado(null, true);
  const { columnsErpType, labelErp } = erpConfig(erp);
  const { controllerDashboard, setControllerDashboard, api } =
    useOutletContext();
  // Carrega ao ler a lista de ERPs e de novo a cada troca de ERP.
  useEffect(() => {
    if (!carregado) return;
    getAllContratos();
    return () => {
      if (controllerDashboard) {
        controllerDashboard.abort();
      }
    };
  }, [carregado, erpId]);

  const chipStatusContrato = (status) => {
    switch (status) {
      case "Em vigência":
        return (
          <Tooltip title={"Em vigência"}>
            <Chip sx={styles.chipVigencia} label={"Em vigência"} />
          </Tooltip>
        );

        break;
      case "Próximo de expirar":
        return (
          <Tooltip title={"Próximo de expirar"}>
            <Chip sx={styles.chipProxima} label={"Próxima de expirar"} />
          </Tooltip>
        );
        break;
      case "Expirado":
        return (
          <Tooltip title={"Expirado"}>
            <Chip sx={styles.chipExpirado} label={"Expirado"} />
          </Tooltip>
        );
        break;
      default:
        return (
          <Tooltip title={"Sem informações"}>
            <Chip sx={styles.chipDefault} label="Sem informações" />
          </Tooltip>
        );
        break;
    }
  };

  useEffect(() => {
    setLoadingBuscar(true);
    const timer = setTimeout(() => {
      const contratosFilter = Array.isArray(allContratos) ? allContratos : [];
      const filtered =
        contratosFilter?.filter((row) => {
          const valorFormt = row?.valor?.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          });

          const matchesSearch =
            row?.id_cliente_servico
              ?.toString()
              ?.includes(buscarContrato?.toLowerCase()) ||
            row?.nome
              ?.toLowerCase()
              ?.includes(buscarContrato?.toLowerCase()) ||
            row?.cpf_cnpj
              ?.toString()
              ?.includes(buscarContrato?.toLowerCase()) ||
            row?.cpf_cnpj
              ?.toLowerCase()
              ?.includes(
                buscarContrato?.replace(/[./-]/g, "")?.toLowerCase(),
              ) ||
            row?.status_servico
              ?.toString()
              ?.toLowerCase()
              ?.includes(buscarContrato?.toLowerCase()) ||
            row?.servico
              ?.toString()
              ?.toLowerCase()
              ?.includes(buscarContrato?.toLowerCase()) ||
            dayjs(row?.data_inicio_contrato)
              .format("DD/MM/YYYY")
              ?.toLowerCase()
              ?.includes(buscarContrato?.toLowerCase()) ||
            dayjs(row?.dataExpiracao)
              .format("DD/MM/YYYY")
              ?.toLowerCase()
              ?.includes(buscarContrato?.toLowerCase()) ||
            valorFormt?.includes(buscarContrato?.toLowerCase());

          const matchesStatus =
            !selectStatusContrato ||
            row?.statusContrato === selectStatusContrato;

          const matchesDate =
            filterData?.initialDate && filterData?.finalDate
              ? row?.dataExpiracao &&
                dayjs(row.dataExpiracao).toDate() >= filterData.initialDate &&
                dayjs(row.dataExpiracao).toDate() <= filterData.finalDate
              : true; // se não houver datas, passa todos

          return matchesSearch && matchesStatus && matchesDate;
        }) || [];

      setFilteredRows(filtered);
      setLoadingBuscar(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [buscarContrato, selectStatusContrato, filterData, allContratos]);

  useEffect(() => {
    setIsValidRange(
      dayjs.isDayjs(startDate) &&
        dayjs.isDayjs(endDate) &&
        startDate.isValid() &&
        endDate.isValid() &&
        !startDate.isAfter(endDate) &&
        !endDate.isBefore(startDate),
    );
  }, [endDate, startDate]);

  const getAllContratos = async () => {
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    try {
      setLoading(true);
      const response = await api.post(
        "/find/allContratos",
        { erpId: erpId || undefined },
        { signal },
      );
      setAllContratos(response?.data);
      setFilteredRows(response?.data);
      setSnackbar({
        children: "Contratos listados com sucesso",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.response?.data?.error || "Ao listar os contratos"
        } `,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleClose = (e) => {
    setAnchorEl(null);
  };
  const handleStartChange = (newValue) => {
    setStartDate(newValue);
    if (newValue?.isAfter(endDate)) {
      setEndDate(newValue);
    }
  };
  const handleEndChange = (newValue) => {
    setEndDate(newValue);
  };
  const handleAplicar = () => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate)
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      finalDate: dayjs(endDate)
        .set("hour", 23)
        .set("minute", 59)
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const handleSelectTime = (key) => {
    setSelectTime(key);
    setStartDate(null);
    setEndDate(null);
    handleClose();

    if (key === 0) {
      setFilterData((prev) => ({
        ...prev,
        initialDate: null,
        finalDate: null,
      }));
      return;
    }
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs()
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      finalDate: optionsTime[key]?.value,
    }));
  };
  const columnsHubsoft = [
    {
      field: "id_cliente_servico",
      headerName: "ID cliente serviço",
      flex: 1,
    },

    {
      field: "nome",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) => {
        const valorExibido = params?.value || "";

        return (
          <Tooltip title={valorExibido} arrow placement="top-start">
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                display: "block",
              }}
            >
              {valorExibido}
            </span>
          </Tooltip>
        );
      },
    },

    {
      field: "cpf_cnpj",
      headerName: "CPF/CNPJ",
      flex: 1,
      renderCell: (params) => {
        return params?.value || params?.row?.cpf_cnpj
          ? maskCpfCnpj(params?.value || params?.row?.cpf_cnpj)
          : "";
      },
    },
    {
      field: "validade",
      headerName: "Validade",
      flex: 1,

      renderCell: (params) => {
        return `${params?.value || ""} ${params?.value > 1 ? "meses" : "mês"}`;
      },
    },

    {
      field: "data_inicio_contrato",
      headerName: "Início Contrato",
      flex: 1,
      renderCell: (params) => {
        return params?.value ? dayjs(params?.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "statusContrato",
      headerName: "Status contrato",
      flex: 1,
      renderCell: (params) => {
        return chipStatusContrato(params?.value);
      },
    },
    {
      field: "dataExpiracao",
      headerName: "Expira em",
      flex: 1,
      renderCell: (params) => {
        return params?.value ? dayjs(params?.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "status_servico",
      headerName: "Status serviço",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {params.value}
        </Box>
      ),
    },

    {
      field: "servico",
      headerName: "Serviço",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ""} arrow placement="top-start">
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              display: "block",
            }}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "valor",
      headerName: "Valor (R$)",
      flex: 1,
      renderCell: (params) => {
        return params?.value
          ? params?.value?.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          : "";
      },
    },
    {
      field: " ",
      headerName: "",
      width: 40, // largura mínima p/ caber o botão
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const clientIsAdd = params?.row?.redirectClient;
        return (
          <IconButton
            size="small"
            disabled={!clientIsAdd}
            onClick={() =>
              navigate(`/interno/home/perfil/servicos/${clientIsAdd}`)
            }
            sx={styles.iconArraw}
          >
            <LaunchOutlined sx={{ fontSize: 16 }} />
          </IconButton>
        );
      },
    },
  ];
  const columnsIxc = [
    {
      field: "id_cliente_servico",
      headerName: "ID Contrato",
      flex: 1,
    },

    {
      field: "nome",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) => {
        const valorExibido = params?.value || "";

        return (
          <Tooltip title={valorExibido} arrow placement="top-start">
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                display: "block",
              }}
            >
              {valorExibido}
            </span>
          </Tooltip>
        );
      },
    },

    {
      field: "cpf_cnpj",
      headerName: "CPF/CNPJ",
      flex: 1,
      renderCell: (params) => {
        return params?.value || params?.row?.cpf_cnpj
          ? maskCpfCnpj(params?.value || params?.row?.cpf_cnpj)
          : "";
      },
    },
    {
      field: "validade",
      headerName: "Validade",
      flex: 1,

      renderCell: (params) => {
        return `${params?.value || ""} ${params?.value > 1 ? "meses" : "mês"}`;
      },
    },

    {
      field: "data_inicio_contrato",
      headerName: "Início Contrato",
      flex: 1,
      renderCell: (params) => {
        return params?.value ? dayjs(params?.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "statusContrato",
      headerName: "Status contrato",
      flex: 1,
      renderCell: (params) => {
        return chipStatusContrato(params?.value);
      },
    },
    {
      field: "dataExpiracao",
      headerName: "Expira em",
      flex: 1,
      renderCell: (params) => {
        return params?.value ? dayjs(params?.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "status_servico",
      headerName: "Status serviço",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {params.value}
        </Box>
      ),
    },

    {
      field: "servico",
      headerName: "Serviço",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ""} arrow placement="top-start">
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              display: "block",
            }}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "valor",
      headerName: "Valor (R$)",
      flex: 1,
      renderCell: (params) => {
        return params?.value
          ? params?.value?.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          : "";
      },
    },
    {
      field: " ",
      headerName: "",
      width: 40, // largura mínima p/ caber o botão
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const clientIsAdd = params?.row?.redirectClient;
        return (
          <IconButton
            size="small"
            disabled={!clientIsAdd}
            onClick={() =>
              navigate(
                `/interno/home/perfil/servicos/${params?.row?.id_contrato}`,
              )
            }
            sx={styles.iconArraw}
          >
            <LaunchOutlined sx={{ fontSize: 16 }} />
          </IconButton>
        );
      },
    },
  ];
  const columnsVoalle = [
    {
      field: "id_cliente_servico",
      headerName: "ID Contrato",
      flex: 1,
    },

    {
      field: "nome",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) => {
        const valorExibido = params?.value || "";

        return (
          <Tooltip title={valorExibido} arrow placement="top-start">
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                display: "block",
              }}
            >
              {valorExibido}
            </span>
          </Tooltip>
        );
      },
    },

    {
      field: "cpf_cnpj",
      headerName: "CNPJ",
      flex: 1,
      renderCell: (params) => {
        return params?.value || params?.row?.cpf_cnpj
          ? maskCnpj(params?.value || params?.row?.cpf_cnpj)
          : "";
      },
    },
    {
      field: "validade",
      headerName: "Validade",
      flex: 1,

      renderCell: (params) => {
        return `${params?.value || ""} ${params?.value > 1 ? "meses" : "mês"}`;
      },
    },

    {
      field: "data_inicio_contrato",
      headerName: "Início Contrato",
      flex: 1,
      renderCell: (params) => {
        return params?.value ? dayjs(params?.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "statusContrato",
      headerName: "Status contrato",
      flex: 1,
      renderCell: (params) => {
        return chipStatusContrato(params?.value);
      },
    },
    {
      field: "dataExpiracao",
      headerName: "Expira em",
      flex: 1,
      renderCell: (params) => {
        return params?.value ? dayjs(params?.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "status_servico",
      headerName: "Status serviço",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {params.value}
        </Box>
      ),
    },

    {
      field: "valor",
      headerName: "Valor (R$)",
      flex: 1,
      renderCell: (params) =>
        params?.value &&
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: " ",
      headerName: "",
      width: 40, // largura mínima p/ caber o botão
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const clientIsAdd = params?.row?.redirectClient;
        return (
          <IconButton
            size="small"
            disabled={!clientIsAdd}
            onClick={() =>
              navigate(
                `/interno/home/perfil/servicos/${params?.row?.id_contrato}`,
              )
            }
            sx={styles.iconArraw}
          >
            <LaunchOutlined sx={{ fontSize: 16 }} />
          </IconButton>
        );
      },
    },
  ];
  const columnsErp = {
    hubsoft: columnsHubsoft,
    ixc: columnsIxc,
    voalle: columnsVoalle,
  };

  const statusOptions = ["Próximo de expirar", "Expirado", "Em vigência"];

  const optionsTime = {
    0: {
      value: dayjs()
        .add(5, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Todos",
    },

    6: {
      value: dayjs()
        .add(2, "day")
        .set("hour", 23)
        .set("minute", 59)
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Expira em 2 dias",
    },
    7: {
      value: dayjs()
        .add(7, "day")
        .set("hour", 23)
        .set("minute", 59)
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Expira em 7 dias",
    },
    8: {
      value: dayjs()
        .add(30, "day")
        .set("second", 0)
        .set("hour", 23)
        .set("minute", 59)
        .set("millisecond", 0)
        .toDate(),
      label: "Expira em 30 dias",
    },
    9: {
      value: dayjs()
        .add(90, "day")
        .set("second", 0)
        .set("hour", 23)
        .set("minute", 59)
        .set("millisecond", 0)
        .toDate(),
      label: "Expira em 90 dias",
    },
    10: {
      value: dayjs()
        .add(6, "month")
        .set("second", 0)
        .set("hour", 23)
        .set("minute", 59)
        .set("millisecond", 0)
        .toDate(),
      label: "Expira em 6 meses",
    },
  };

  const actions = [
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
  ];

  return (
    <Box sx={styles.boxContainer}>
      <FilterBar
        actions={actions}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
        selectorComponentLeft={
          <Box
            sx={{
              display: "flex",
              gap: 1,
              "@media (max-width: 1349px)": { flexDirection: "column" },
              width: "100%",
            }}
          >
            {variosErps && (
              <ErpFilter
                erps={erps}
                value={erpId}
                onChange={(novoErpId) => novoErpId && setErpId(novoErpId)}
                limpavel={false}
                id="filtro-erp-contratos"
                sx={{ minWidth: 200 }}
              />
            )}
            <TextField
              label="Buscar Contrato"
              variant="outlined"
              autoComplete="off"
              placeholder="Nome, serviço, etc..."
              value={buscarContrato}
              size="small"
              onChange={(event) => {
                setBuscarContrato(event?.target?.value);
              }}
              sx={{
                ...styles.textfield,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: buscarContrato ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setBuscarContrato("")}
                      edge="end"
                    >
                      <Clear size={"small"} />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
            <Autocomplete
              sx={styles.autocomplete}
              id="status-contrato"
              value={selectStatusContrato}
              disabled={loading}
              renderValue={(value, getItemProps) => {
                return (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    {chipStatusContrato(value)}
                  </Box>
                );
              }}
              size="small"
              options={statusOptions}
              getOptionLabel={(option) => option || ""}
              onChange={(event, newValue) => {
                setSelectStatusContrato(newValue);
              }}
              renderOption={(props, option) => (
                <li {...props}>{chipStatusContrato(option)}</li>
              )}
              renderTags={(value, getTagProps) =>
                value ? [chipStatusContrato(value)] : []
              }
              renderInput={(params) => (
                <TextField {...params} label={"Status do contrato"} />
              )}
            />
          </Box>
        }
        selectorComponentRight={
          <Box sx={{}}>
            <ButtonTime
              open={open}
              optionsTime={optionsTime}
              selectTime={selectTime}
              handleClick={handleClick}
              anchorEl={anchorEl}
              handleClose={handleClose}
              loading={loading}
              handleStartChange={handleStartChange}
              handleEndChange={handleEndChange}
              handleAplicar={handleAplicar}
              isValidRange={isValidRange}
              endDate={endDate}
              startDate={startDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              setSelectTime={setSelectTime}
              handleSelectTime={handleSelectTime}
              filterData={filterData}
              DateTime={DatePicker}
            />
          </Box>
        }
      />
      <Paper
        sx={styles.containerPaper}
        elevation={theme.palette.mode === "dark" ? 0 : 3}
      >
        <Typography variant="mySubtitle">Contratos</Typography>

        <Box sx={styles.boxDatagrid}>
          <DatagridComponent
            loading={loading || loadingBuscar}
            rows={filteredRows}
            columns={columnsErpType ? columnsErp[columnsErpType] : []}
          />
        </Box>
      </Paper>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
